import { combineReducers, createStore, compose, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import { isDev } from './utils';
import appReducer from './actions';

const reducers = combineReducers( { app: appReducer } )

const composeFunction = isDev()
  ? composeWithDevTools({ trace: true, traceLimit: 25 })
  : compose;


const store =  createStore(
    reducers,
    composeFunction(applyMiddleware(thunk))
);
export default store;

